import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="222371" id="cart-content" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="mb-12">
          <h1 className="font-default text-4xl md:text-5xl font-bold tracking-tighter text-secondary uppercase">
            Ihr Warenkorb
          </h1>
          <div className="h-px w-full bg-border mt-8 opacity-50"></div>
        </div>
        
        <div className="w-full min-h-[40vh] rounded-xl overflow-hidden shadow-sm">
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}